import * as echarts from "echarts";
export function loadChart(myChart, obj /* , unit */) {
  // var line = ["12", "4", "6", "8", "10", "12"];
  // var year = ["1月", "4月", "6月", "8月", "10月", "12月"];
  var unit = "亩";
  var year = [];
  var line = [];
  for (var i = 0; i < obj.length; i++) {
    line.push(obj[i].sum);
    year.push(obj[i].year_month);
  }
  myChart.setOption({
    legend: {
      show: false
    },
    grid: {
      right: 20,
      left: 24,
      top: 30,
      bottom: 20
    },
    tooltip: {
      trigger: "axis",
      axisPointer: {
        type: "none"
      },
      formatter: function(params) {
        return (
          params[0].name +
          "<br/>" +
          "<span style='display:inline-block;margin-right:5px;border-radius:10px;width:9px;height:9px;background-color:rgba(36,207,233,0.9)'></span>" +
          params[0].seriesName +
          " : " +
          Number(params[0].value) +
          unit +
          " <br/>"
        );
      }
    },
    xAxis: [
      {
        type: "category",
        axisLine: {
          show: false,
          lineStyle: {
            color: "#fff"
          }
        },
        splitArea: {
          color: "#f00",
          lineStyle: {
            color: "#f00"
          }
        },
        axisLabel: {
          lineStyle: {
            color: "rgba(255, 255, 255, 0.8)"
          }
        },
        splitLine: {
          show: false
        },
        axisTick: {
          show: false
        },
        boundaryGap: false,
        data: year
      }
    ],

    yAxis: [
      {
        name: "(" + unit + ")",
        nameGap: 8,
        nameTextStyle: {
          color: "#fff",
          fontSize: 14
        },
        type: "value",
        splitLine: {
          show: true,
          lineStyle: {
            color: "#535e68",
            type: "dashed"
          }
        },
        axisLine: {
          show: true,
          lineStyle: {
            color: "#535e68"
          }
        },
        axisLabel: {
          show: true,
          margin: 10,
          textStyle: {
            color: "rgba(255, 255, 255, 0.8)"
          }
        },
        axisTick: {
          show: false,
          lineStyle: {
            color: "#6c50f3"
          }
        },
        min: function(value) {
          return value.min;
        },
        max: function(value) {
          return value.max;
        }
      }
    ],
    series: [
      {
        name: "作业面积",
        type: "line",
        smooth: true, //是否平滑
        showAllSymbol: true,
        // symbol: 'image://./static/images/guang-circle.png',
        symbol: "circle",
        symbolSize: 10,
        lineStyle: {
          normal: {
            // color: "#00b3f4",
            color: "rgb(15, 150, 245)",
            shadowColor: "rgba(0, 0, 0, .3)",
            shadowBlur: 0,
            shadowOffsetY: 5,
            shadowOffsetX: 5
          }
        },
        label: {
          show: false,
          position: "top",
          textStyle: {
            color: "#00b3f4"
          }
        },
        itemStyle: {
          color: "#fff",
          borderColor: "#00b3f4",
          borderWidth: 1,
          shadowColor: "rgba(0, 0, 0, .3)",
          shadowBlur: 0,
          shadowOffsetY: 2,
          shadowOffsetX: 2
        },
        // tooltip: {
        //     show: true
        // },
        areaStyle: {
          normal: {
            color: new echarts.graphic.LinearGradient(
              0,
              0,
              0,
              1,
              [
                {
                  offset: 0,
                  color: "rgba(14, 156, 255,0.5)"
                },
                {
                  offset: 1,
                  color: "rgba(14, 156, 255,0.0)"
                }
              ],
              false
            ),
            shadowColor: "rgba(0,179,244, 0.9)",
            shadowBlur: 20
          }
        },
        data: line
      }
    ]
  });
}
